var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.159,
    height: 73.959,
    viewBox: "0 0 65.159 73.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save-money",
    transform: "translate(-0.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23566",
    "data-name": "Path 23566",
    d: "M191.32,165.072a1.155,1.155,0,0,0-.416-.014,2.758,2.758,0,0,1-2.439-2.735,1.213,1.213,0,0,0-2.426,0,5.19,5.19,0,0,0,3.816,5v1.213a1.213,1.213,0,1,0,2.426,0v-1.14a5.18,5.18,0,0,0-1.062-10.251,2.754,2.754,0,1,1,2.754-2.754,1.213,1.213,0,0,0,2.426,0,5.19,5.19,0,0,0-4.119-5.071v-1.1a1.213,1.213,0,0,0-2.426,0v1.178a5.18,5.18,0,0,0,1.365,10.177,2.753,2.753,0,0,1,.1,5.5Zm0,0",
    transform: "translate(-157.522 -124.709)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23567",
    "data-name": "Path 23567",
    d: "M104.195,124.084a17.592,17.592,0,1,0,17.592-17.592A17.592,17.592,0,0,0,104.195,124.084Zm17.592-15.165a15.165,15.165,0,1,1-15.165,15.165A15.165,15.165,0,0,1,121.787,108.918Zm0,0",
    transform: "translate(-88.089 -90.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23568",
    "data-name": "Path 23568",
    d: "M57.269,331.189l-9.5,4.49a7.74,7.74,0,0,0-6.6-4.072l-8.773-.241a9.266,9.266,0,0,1-3.987-1.03l-.893-.463a15.746,15.746,0,0,0-14.584.015l.056-2.022a1.213,1.213,0,0,0-1.179-1.246l-9.62-.265a1.213,1.213,0,0,0-1.246,1.179L.36,348.646a1.213,1.213,0,0,0,1.179,1.246l9.62.265h.033a1.213,1.213,0,0,0,1.213-1.18l.028-1.01,2.5-1.338a4.287,4.287,0,0,1,3.2-.35l14.924,4.189c.026.008.052.014.079.02a15.977,15.977,0,0,0,3.28.338,16.186,16.186,0,0,0,6.762-1.476,1.124,1.124,0,0,0,.15-.083l21.638-14a1.214,1.214,0,0,0,.4-1.616,6.128,6.128,0,0,0-8.093-2.465ZM2.819,347.5l.514-18.685,7.194.2L10.013,347.7Zm39.264-.318a13.755,13.755,0,0,1-8.411.939l-14.883-4.178a6.708,6.708,0,0,0-5,.547l-1.277.684.342-12.423a13.335,13.335,0,0,1,13.547-.723l.893.463a11.717,11.717,0,0,0,5.036,1.3l8.773.241a5.321,5.321,0,0,1,5.057,4.24l-13.068-.361a1.213,1.213,0,0,0-.067,2.426l14.421.4h.034a1.213,1.213,0,0,0,1.212-1.18,7.7,7.7,0,0,0-.117-1.574l9.747-4.606.028-.014a3.707,3.707,0,0,1,4.191.587Zm0,0",
    transform: "translate(0 -276.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23569",
    "data-name": "Path 23569",
    d: "M214.629,12.738V1.213a1.213,1.213,0,1,0-2.426,0V12.738a1.213,1.213,0,1,0,2.426,0Zm0,0",
    transform: "translate(-179.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23570",
    "data-name": "Path 23570",
    d: "M274.629,46.672V41.213a1.213,1.213,0,1,0-2.426,0v5.459a1.213,1.213,0,1,0,2.426,0Zm0,0",
    transform: "translate(-230.62 -33.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23571",
    "data-name": "Path 23571",
    d: "M154.629,46.672V41.213a1.213,1.213,0,1,0-2.426,0v5.459a1.213,1.213,0,1,0,2.426,0Zm0,0",
    transform: "translate(-128.817 -33.934)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.25aad7ed8055d6e673929b1426db7f91.svg";
export { ForwardRef as ReactComponent };